import axiosInstance from 'helpers/axiosInstance';

export interface UpdateOnBoardingResponse {
  success: boolean;
  errors?: string[];
}

export const updateOnboardingHint = async (
  program: string,
): Promise<UpdateOnBoardingResponse> => {
  const url = '/patients/accounts/update_onboarding_hint';

  const response = await axiosInstance.patch<UpdateOnBoardingResponse>(url, {
    account: { onboarding_hint: program },
  });
  return response.data;
};
